module.exports = __webpack_public_path__ + "static/img/call_of_data_thumbnail.4316c31.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/call_of_data_thumbnail.png
// module id = JnVh
// module chunks = 9